import React, { useState, useEffect } from 'react'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import BlacklistedWidget from '../../../widgets/blacklistPagesWidgets/blacklisted/BlacklistedWidget'
import { callBlacklisted } from '../../../redux/actions/blacklist'
import TopLevelNav from '../../../components/TopLevelNav'
import PageToolbar from '../../../components/PageToolbar'
//รายการผู้ทิ้งงาน
export default function Blacklisted() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async (pageNum, pageSize) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await callBlacklisted(pageNum || 1, pageSize || 5)
      // console.log('mockSchema ', _schema)
      setSchema(_schema.model)
      // setSchema(mockSchema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </div>
    )
  }

  if (!schema || isLoading) {
    return (
      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <PanalLoadingTemplate />
      </div>
    )
  }

  return (
    <div className="custom-dashboard">
      <TopLevelNav />
      <PageToolbar />
      {/* <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton /> */}
      <BlacklistedWidget schema={schema} isViewMode={schema.disabled} />
      {/* periodNumber={periodNumber} projectCode={projectCode} */}
      <br />
    </div>
  )
}
